import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useStyles, LinkCopyButton, LinkSendButton } from './style/style';
import { sendFileShareUrl } from '../../../apicalls/cloud/shareFile';
import { sendPictureShareUrl } from '../../../apicalls/cloud/sharePicture';
import { SendEmailModal } from './SendEmailModal';
import { checkResData } from '../../../utils/common';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../../tooltip/CustomTooltip';

type TProps = {
  id: number;
  name: string;
  email: string;
  url: string;
  isFileMode?: boolean;
};

export const LinkArea = (props: TProps) => {
  const { id, name, email, url, isFileMode } = props;

  const linkSendButtonDisabled = email === '';

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  // スタイル読み込み
  const classes = useStyles();
  // リンクURLコピーの成否メッセージ
  const [copyStateMessage, setCopyStateMessage] = useState<string>();
  // コピーの成否メッセージの表示フラグ
  const [openCopyStateMessage, setOpenCopyStateMessage] =
    useState<boolean>(false);
  // メール送信モーダルの表示フラグ
  const [openSendEmailModal, setOpenSendEmailModal] = useState<boolean>(false);

  const dataType: string =
    history.location.pathname === '/files' ? '資料' : '写真';

  // ツールチップ内部
  const ShareLinkInfo = (
    <>
      <div style={{ padding: 4 }}>
        <div style={{ fontSize: 14 }}>このリンク（URL）にアクセスすると</div>
        <div style={{ fontSize: 14 }}>フォルダ内の{dataType}を参照できます</div>
      </div>
    </>
  );

  const handleCopyStateMessage = (message: string) => {
    setCopyStateMessage(message);
    setOpenCopyStateMessage(true);
    setTimeout(() => {
      setOpenCopyStateMessage(false);
    }, 3000);
  };

  const copyLinkUrl = () => {
    navigator.clipboard.writeText(url).then(
      () => {
        handleCopyStateMessage('コピーしました。');
      },
      () => {
        handleCopyStateMessage('コピーできませんでした。');
      }
    );
  };

  const sendEmail = () => {
    //  isFileMode（資料一覧の検索） 又は 開いているページによってメールを送信するAPIを変更
    const sendShareUrl =
      isFileMode || history.location.pathname === '/files'
        ? sendFileShareUrl
        : sendPictureShareUrl;
    sendShareUrl(id).then(resData => {
      checkResData(resData, enqueueSnackbar);
    });
  };

  return (
    <>
      <Grid
        xs={10}
        style={{
          backgroundColor: '#EFEFEF',
          padding: 24,
          borderRadius: 8
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p style={{ margin: '4px 0' }}>共有リンク</p>
          <CustomTooltip title={ShareLinkInfo} placement='right' interactive>
            <HelpIcon color='action' style={{ marginLeft: 16 }} />
          </CustomTooltip>
        </div>
        <p style={{ margin: '4px 0', wordBreak: 'break-all' }}>{url}</p>

        <div style={{ display: 'flex', marginTop: 16 }}>
          <LinkCopyButton variant='contained' onClick={copyLinkUrl}>
            リンクをコピー
          </LinkCopyButton>

          <LinkSendButton
            variant='contained'
            disabled={linkSendButtonDisabled}
            onClick={() => setOpenSendEmailModal(true)}
          >
            メールで送信
          </LinkSendButton>
        </div>
      </Grid>

      {/* リンクURLのコピー成否メッセージ */}
      {openCopyStateMessage && (
        <div className={classes.copyStateMessage}>
          <div>{copyStateMessage}</div>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => setOpenCopyStateMessage(false)}
          >
            OK
          </div>
        </div>
      )}

      {/* メール送信モーダル */}
      <SendEmailModal
        name={name}
        email={email}
        sendEmail={sendEmail}
        openModal={openSendEmailModal}
        setOpenModal={setOpenSendEmailModal}
      />
    </>
  );
};
